<template>
  <n-layout>
    <n-layout-header>
      <Header :plainLogo="true" />
    </n-layout-header>
    <n-layout-content
      content-style="height: calc(100vh - 64px); overflow-y: auto"
      data-scroll-container
    >
      <slot />
    </n-layout-content>
  </n-layout>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
